import {
    ExperienceViewItem,
    ExperienceViewResponseDto,
    ExperienceViewItemType,
} from "types/experience-view";

/**
 * Maps the overview response to listing items, experiences first, narrowed to the `sectionIds` URL
 * filter. The overview endpoint does not take that filter, so it is applied here with
 * availableTimes' rule: an experience is kept only when all of its sections are.
 */
function mapExperienceViewResponse(
    response: ExperienceViewResponseDto,
    sectionIds?: number[]
): ExperienceViewItem[] {
    const sectionFilter = sectionIds?.length ? new Set(sectionIds) : null;
    const isInFilter = (sectionId: number) => !sectionFilter || sectionFilter.has(sectionId);

    const experienceItems: ExperienceViewItem[] = response.experiences
        .filter((exp) => (exp.sectionIds ?? []).every(isInFilter))
        .map((exp) => ({
            id: exp.id,
            activeDates: exp.activeDates ?? [],
            name: exp.name,
            description: exp.description,
            imageReference1x1: exp.imageReference1x1 ?? "",
            imageReference16x9: exp.imageReference16x9 ?? "",
            type: ExperienceViewItemType.Experience,
            sectionIds: exp.sectionIds ?? [],
            bookingRequestEnabled: exp.bookingRequestEnabled ?? false,
            bookingRequestOnly: exp.bookingRequestOnly ?? false,
            informationOnly: exp.informationOnly ?? false,
        }));

    const sectionItems: ExperienceViewItem[] = response.sections
        .filter((section) => isInFilter(section.id))
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((section) => ({
            id: section.id,
            sectionIds: [], // Sections don't have nested sections, so this can be an empty array
            activeDates: [],
            name: section.name,
            description: section.description,
            imageReference1x1: section.image,
            imageReference16x9: section.image,
            type: ExperienceViewItemType.Section,
        }));

    return [...experienceItems, ...sectionItems];
}

export { mapExperienceViewResponse };
